/** @format */
import Checklist from "@Workspace/Components/Checklist";

export default function () {
  return <Checklist limit={5} show="incomplete" />;
}
